module.exports = __webpack_public_path__ + "static/media/import-export-arrows.99b6bd04.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/import-export-arrows.svg
// module id = 2038
// module chunks = 32